<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :title="title"
            :load_url="load_url"
            :options="options"
            :options_label="options_text">

    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'TodaysInventoryProcessedByHour',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            return {
                chart_type: true,
                color: '#76d561',
                title: 'Inventory Processed by agent',
                load_url: '/dashboards/TodaysProcessedInventoryByAgent',
                options: ['today', 'yesterday','last7days','this_month','last_month'],
                options_text: ['Today', 'Yesterday','Last 7 Days','This Month','Last Month'],
                time_wait: 10000,
            };
        },
    };
</script>

<style scoped>

</style>